document.addEventListener('DOMContentLoaded', function(dom) {
  const notification = dom.target.querySelector('.part-notification');
  let notificationIsClose = JSON.parse(sessionStorage.getItem('notification-is-close'));

  // Fonction pour mettre à jour la variable CSS --notificationbar-height
  function updateNotificationHeight() {
    const height = notificationIsClose || !notification ? 0 : notification.offsetHeight;
    document.body.style.setProperty('--notificationbar-height', `${height}px`);
  }

  if (notification) {
    const notificationClose = notification.querySelector('.js-close-notification');

    // Mettre à jour la hauteur au chargement
    if (notificationIsClose) {
      notification.style.display = 'none'
    }

    window.addEventListener('load', updateNotificationHeight);
    window.addEventListener('resize', updateNotificationHeight);

    if (notificationClose) {
      notificationClose.addEventListener('click', function(e) {
        sessionStorage.setItem('notification-is-close', 'true');
        notification.style.display = 'none';
        notificationIsClose = true;

        // Mettre à jour la hauteur après la fermeture
        updateNotificationHeight();
      });
    }
  }
});
